import { Sprout } from "lucide-react";

const ITEMS = [
  "Play",
  "Emotion",
  "Growth",
  "Child Development",
  "Stress Release",
  "Mantra Care Verified",
  "A Safe Haven for Families",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-[#FDFBF7]/90 sm:text-3xl">
          {item}
        </span>
        <Sprout size={20} className="shrink-0 text-[#D97706]" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden bg-[#064E3B] py-5" aria-hidden="true">
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
